import siteInfo from './config';

const strings = {};

for (let language of siteInfo.languages) {
    strings[language] = require(`../../content/${language}/strings.yml`);
}

export default strings;
